import { createBrowserRouter } from "react-router-dom";
import AUTH_ROUTES from "./auth";
import SALES_ROUTES from "./sales";
import AuthGaurd from "components/gaurds/AuthGaurd";
import AppLayout from "layouts/AppLayout";
import Dashboard from "pages/dashboard/Dashboard";
import Home from "pages/Home";
import CONTACTS_ROUTES from "./contacts";
import MyErrorBoundary from "components/errorBoundry/MyErrorBoundary";
import RedirectToWeb from "pages/RedirectToWeb";

const router = createBrowserRouter([
  {
    element: <MyErrorBoundary />,
    children: [
      {
        path: "en/index/sales/sales-orders/:id",
        element: <RedirectToWeb />,
      },
      {
        path: "en/index/sales-fulfilment/invoices/:id",
        element: <RedirectToWeb />,
      },
      {
        path: "/",
        element: <Home />,
      },
      ...AUTH_ROUTES,
      {
        path: "dashboard",
        element: (
          <AuthGaurd>
            <AppLayout />
          </AuthGaurd>
        ),
        children: [
          { path: "", element: <Dashboard /> },
          ...SALES_ROUTES,
          ...CONTACTS_ROUTES,
        ],
      },
    ],
  },
]);

export default router;
